export default __webpack_public_path__ + "static/media/BenifitOne.45795129.svg";